import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Card } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { useIsAggregatedAirline } from "../../../hooks/useIsAggregatedAirline";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { ChartErrorBoundary } from "../ChartErrorBoundary";
import { ChartSuspense } from "../ChartSuspense";
import {
  DiscountedBookingsChartLoader,
  type DiscountedBookingsChartLoaderProps,
} from "./DiscountedBookingsChartLoader";

export type DiscountedBookingsChartCardProps = DiscountedBookingsChartLoaderProps;

export const DiscountedBookingsChartCard = (props: DiscountedBookingsChartCardProps) => {
  const i18n = useI18n();
  const { selectedAirline, selectedAirlineCodes } = useSelectedAirline();
  const isAggregatedAirline = useIsAggregatedAirline();

  return (
    <Card mixin={{ paddingBlockStart: 6, paddingInlineStart: 6 }}>
      <div
        className={
          !(isAggregatedAirline && selectedAirlineCodes.length > 1)
            ? "apexcharts-container apexcharts-line-chart"
            : undefined
        }
      >
        <ErrorBoundary
          resetKeys={[props.from, props.to, selectedAirline?.code]}
          fallback={
            <ChartErrorBoundary
              titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_name"))}
            />
          }
        >
          <Suspense
            fallback={
              <ChartSuspense titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_name"))} />
            }
          >
            <DiscountedBookingsChartLoader {...props} />
          </Suspense>
        </ErrorBoundary>
      </div>
    </Card>
  );
};
